/* eslint-disable import/no-cycle */
import { combineReducers } from 'redux';

import rootAdminReducer from '@/admin/rootReducer';
import rootReducer from '@/rootReducer';

const createRootReducer = () =>
	combineReducers({
		...rootReducer(),
		...rootAdminReducer(),
	});

export default createRootReducer;
